import React from "react";
import { CSSTransition } from "react-transition-group";
import { useDialogContext } from "./DialogProvider";

const DialogContainer: React.FC = () => {
  const {
    dialogComponent: Component,
    dialogProps,
    isOpen,
  } = useDialogContext();

  return (
    <CSSTransition in={isOpen} timeout={200} classNames={"modal"} unmountOnExit>
      {Component ? <Component {...dialogProps} /> : <></>}
    </CSSTransition>
  );
};

export default DialogContainer;
